import { UPGRADES_MAP } from '@flows/configs/contents/constants'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_glass = (params: ContentsNeoStepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.glass.title',
        },
        /**
         * TODO: we hardcoded the price for now
         * introduce back dynamic price for extension
         * when we are supporting interpollation value for inline translations
         * https://hellogetsafe.atlassian.net/browse/BFPC-662
         */
        // cms: {
        //   product: glassProductKey,
        //   value: 'roughMonthlyPremium',
        // },
      },
      {
        type: 'choice',
        name: `product_keys.${UPGRADES_MAP.glassProductKey[params.productKey]}`,
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contents:steps.contents.glass.info.text',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_bike',
  }) as const satisfies AnyStepConfiguration

export default contents_glass
